import { useState } from 'react';
import Modal from '@mui/material/Modal';
import ErrorHandler from '@Root/ErrorHandler';
import { IoClose as Close } from 'react-icons/io5';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import BorderRedButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderRedButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import FieldService from '@Helpers/URLHelpers/FieldService';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import './DeleteFieldForm.scss';

export default function DeleteFieldForm(props) {
    const [cursor, setCursor] = useState('auto');
    const errorHandler = new ErrorHandler();
    const fieldPageService = new FieldPageService();
    const fieldService = new FieldService();
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    const className = 'deleteFieldForm';

    const timeout = (delay) => new Promise(res => setTimeout(res, delay));

    const handleDelete = async (e) => {
        e?.preventDefault();
        setCursor('wait');
        try {
            let fieldsListObj = JSON.parse(props.fieldPage.fields);
            fieldsListObj = fieldsListObj.filter(id => id !== props.field?.id);
            let fieldPageObj = props.fieldPage;
            fieldPageObj.fields = JSON.stringify(fieldsListObj);
            await fieldPageService.updateFieldPage(fieldPageObj);

            let detailsObj = JSON.parse(props.kaiziqResolveConnection.details);
            detailsObj.fields.form = detailsObj.fields.form.filter(id => id !== props.field?.id);
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(
                props.kaiziqResolveConnection.id,
                JSON.stringify(detailsObj)
            );

            await fieldService.deleteField({ id: props.field.id });
            await timeout(500);
            await props?.renderData();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}
        >
            <div className={className + '__inner flex-column-flex-start'}>
                <div className={className + '__inner__titleBar width-wfa'}>
                    <div className={className + '__inner__titleBar__title flex-row-flex-end standard-text-semi-large red-text semi-bold-text'}>
                        <DeleteIcon className={className + '__inner__titleBar__title__icon'} />
                        Delete Field
                    </div>
                    <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup} />
                </div>
                <div className={className + '__inner__name flex-column-flex-start'}>
                    <div className={className + '__inner__name__tag large-text'}>
                        {props.field?.title}
                    </div>
                </div>
                <form className={className + '__inner__form flex-column-flex-start width-wfa'} onSubmit={handleDelete}>
                    <div className={className + '__inner__form__info flex-column-flex-start'}>
                        <div className={className + '__inner__form__info__t1'}>Are you sure you want to delete this field?</div>
                        <div className={className + '__inner__form__info__t2 grey-text small-text'}>
                            All data associated with this field will be permanently removed.
                        </div>
                    </div>
                    <div className={className + '__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                        <div className={className + '__inner__form__buttonFlex__delete width-wfa'}>
                            <BorderRedButtonV2
                                text="Delete"
                                onClick={handleDelete}
                                disabled={cursor === 'wait'}
                            />
                        </div>
                        <div className={className + '__inner__form__buttonFlex__cancel width-wfa'}>
                            <BorderWhiteButtonV2
                                text="Cancel"
                                onClick={props.closePopup}
                                disabled={cursor === 'wait'}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
